import React, { useState, useEffect } from 'react';
import { Col, Row, Form, FormGroup, Input, Button, Card, CardBody, CardHeader, Spinner, Label } from 'reactstrap';
import makeAnimated from 'react-select/animated';
import ReadMoreContent from '../Utilities/Ui/ReadMore';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import './CatchmentContext.css';
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tooltip as ReactTooltip } from "react-tooltip";
import Select from 'react-select';
import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";

const animatedComponents = makeAnimated();

const CatchmentOverview = ({ setCatchmentOverviewChanged, overviewDescription, setOverviewDescription, culturalValuesDescription, setCulturalValuesDescription,
    freshwaterValuesPrioritiesOutcomes, setFreshwaterValuesPrioritiesOutcomes, priorityContaminantSelectedValues, setPriorityContaminantSelectedValues,
    handleCatchmentOverviewSubmit
}) => {
    const roleName = localStorage.getItem("roleName");
    const saveRightsForNonItemFieldsAndTables = localStorage.getItem("saveRightsForNonItemFieldsAndTables");
    const [saving, setSaving] = useState('');
    /*const [overviewDescription, setOverviewDescription] = useState('');*/
    /*const [culturalValuesDescription, setCulturalValuesDescription] = useState('');*/
    /*const [freshwaterValuesPrioritiesOutcomes, setFreshwaterValuesPrioritiesOutcomes] = useState('');*/
    const [overview, setOverview] = useState('');
    const [culturalValues, setCulturalValues] = useState('');
    const [farmId] = useState(localStorage.getItem("defaultFarmId"));
    const [userId] = useState(localStorage.getItem("loggedInUserId"));
    const [priorityContaminantList, setPriorityContaminantList] = useState([]); const [priorityContaminantListSelectedValues, setPriorityContaminantListSelectedValues] = useState([]);
    /*const [priorityContaminantSelectedValues, setPriorityContaminantSelectedValues] = useState('');*/
    useEffect(() => {
        getOverview();

    }, [])

    const getOverview = async () => {
        try {
            const response = await apiGet('/api/catchmentContext/getCatchmentOverview/', {
                params: {
                    farmId: farmId
                }
            });

            setOverview(response?.data?.overview);
            setCulturalValues(response?.data?.culturalValues);
            setOverviewDescription(response?.data?.overviewDescription);
            setCulturalValuesDescription(response?.data?.culturalValuesDescription);
            setFreshwaterValuesPrioritiesOutcomes(response?.data?.freshwaterValuesPrioritiesOutcomes);
            setPriorityContaminantList(response?.data?.priorityContaminantList);

            if (response?.data?.selectedPriorityContaminantList.length > 0) {
                var priorityContaminantSelectedValues = '';
                response?.data?.selectedPriorityContaminantList.forEach(function (element) {
                    if (priorityContaminantSelectedValues == '') {
                        priorityContaminantSelectedValues = element.value;
                    }
                    else {
                        priorityContaminantSelectedValues = priorityContaminantSelectedValues + ',' + element.value;
                    }
                });
                setPriorityContaminantSelectedValues(priorityContaminantSelectedValues);
                setPriorityContaminantListSelectedValues(response?.data?.selectedPriorityContaminantList);
            }
            else {
                setPriorityContaminantListSelectedValues([]);
            }

        } catch (error) {
            if (!error?.response) {
                toast.error(error.response?.status + ": " + error.message);
            } else {
                toast.error("No server response");
            }
        }
    }

    

    const CatchmentInfo = () => (
        <div>
            <p>If you need more space in any of these just click on the small diagonal lines at the bottom right-hand side of the text box and drag the box down. It will expand to suit your needs. Remember to always hit Save when you’re done so you don’t lose any work.</p>
        </div>
    );
    const CatchmentInfoId = "CatchmentInfoId";
    const showCatchmentInfoMessage = (e) => {
        e.stopPropagation();
        toastytoast.info(CatchmentInfo, {
            autoClose: false, theme: "colored", hideProgressBar: true, icon: false, toastId: CatchmentInfoId, rtl: false
        });
    };

    const FrestwaterValues = () => (
        <div>
            <p>If you need more space in any of these just click on the small diagonal lines at the bottom right-hand side of the text box and drag the box down. It will expand to suit your needs. Remember to always hit Save when you’re done so you don’t lose any work.</p>
        </div>
    );
    const FrestwaterValuesId = "FrestwaterValuesId";
    const showFrestwaterValuesMessage = (e) => {
        e.stopPropagation();
        toastytoast.info(FrestwaterValues, {
            autoClose: false, theme: "colored", hideProgressBar: true, icon: false, toastId: FrestwaterValuesId, rtl: false
        });
    };

    const handleChange = (e) => {
        setCatchmentOverviewChanged(true);
        setPriorityContaminantSelectedValues('');
        var priorityContaminantSelectedValues = '';
        setPriorityContaminantListSelectedValues(e);
        e.forEach(function (element) {
            if (priorityContaminantSelectedValues == '') {
                priorityContaminantSelectedValues = element.value;
            }
            else {
                priorityContaminantSelectedValues = priorityContaminantSelectedValues + ',' + element.value;
            }
        });
        setPriorityContaminantSelectedValues(priorityContaminantSelectedValues);
    }

    return (
        <>
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <CardBody>
                <Form >
                    <Row>
                        <Col sm="12">
                            <Card style={{ minHeight: "300px" }}>
                                <CardHeader className="card-header-dark">
                                    <h5>Catchment Information&nbsp;&nbsp;&nbsp;
                                        <img className="featureIcon" src="/images/info_button_lt.png" data-tooltip-id="my-tooltip-3" onClick={(e) => e.stopPropagation()} /></h5>
                                    <ReactTooltip opacity="1" className="overrideMe" globalCloseEvents={{ escape: true, clickOutsideAnchor: true, scroll: true, resize: true }} openOnClick="true" clickable="true" style={{ marginTop: "-1vh", backgroundColor: "#e2f2f3", color: "black", maxWidth: "25vw", fontWeight: "750", wordBreak: 'normal', overflowWrap: 'break-word' }}
                                        id="my-tooltip-3"
                                        place="top"
                                        variant="info"
                                        render={({ content, activeAnchor }) => (
                                            <>
                                                <Row>
                                                    <Col>
                                                        <p style={{ fontWeight: "lighter" }}>
                                                            Describe the catchment context, challenges, and values including the following information, where relevant, in relation to your local area:
                                                        </p>
                                                        <p style={{ fontWeight: "lighter" }}>
                                                            (a) existing information on landforms, soil data, climate data, freshwater data, freshwater bodies, contaminants, sites that are significant to the community, and significant species or ecosystems:
                                                        </p>
                                                        <p style={{ fontWeight: "lighter" }}>
                                                            (b) identified cultural matters of importance to tangata whenua, including—<br />
                                                            <span style={{ marginLeft: "10px" }}>(i) the cultural significance of the local area; and</span><br />
                                                            <span style={{ marginLeft: "10px" }}>(ii) the traditional names of freshwater bodies in the local area;</span><br />
                                                            <span style={{ marginLeft: "10px" }}>(iii) sites and species in the local area that are significant to tangata whenua:</span><br />
                                                        </p>
                                                        <p style={{ fontWeight: "lighter" }}>
                                                            (c) any objectives, policies, and rules relevant to the management of freshwater or freshwater ecosystems in policy statements or the regional plan:
                                                        </p>
                                                        <p style={{ fontWeight: "lighter" }}>
                                                            (d) any relevant freshwater matters in planning documents that are recognised by iwi authorities and lodged with the regional council:
                                                        </p>
                                                        <p style={{ fontWeight: "lighter" }}>
                                                            (e) the National Policy Statement for Freshwater Management and any action plans made by the regional council:
                                                        </p>
                                                        <p style={{ fontWeight: "lighter" }}>
                                                            (f) any secondary legislation made under the Act that is relevant to the management of freshwater or freshwater ecosystems (other than secondary legislation made under Part 9A of the Act)
                                                        </p>
                                                        <p style={{ fontWeight: "lighter" }}>
                                                            Many of the regional councils have compiled information on localised catchment areas. Use this information to identify potential risks to freshwater quality in your area. See your local council for further information relating to catchment context, challenges and values for your catchment area.
                                                        </p>
                                                    </Col>
                                                </Row>
                                            </>
                                        )}
                                    />
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col>
                                            {/*<ReadMoreContent longText="Overview of the catchment including any areas that are sensitive to farming activities. Include biophysical characteristics such as soil, climate, freshwater data, and freshwater bodies." />*/}
                                            <p>Describe the catchment area your property is situated in. Further information can be found under the information button (‘i’) and from information provided by your regional council.</p>
                                            <FormGroup>
                                                <Row className="mb-3">
                                                    <Col sm={12}>
                                                        <Input
                                                            id="overviewDescription"
                                                            name="overviewDescription"
                                                            type="textarea"
                                                            value={overviewDescription}
                                                            onChange={(e) => { setOverviewDescription(e.target.value); setCatchmentOverviewChanged(true); }}
                                                        />
                                                    </Col>
                                                </Row>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm="6">
                                            <FormGroup>
                                                <Label className="label" for="significantspecies">Catchment priority Contaminants</Label>
                                                <Select className="dropdown" placeholder="Select Option" value={priorityContaminantListSelectedValues} options={priorityContaminantList} onChange={handleChange} isMulti isClearable />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>

                        </Col>
                        {/*<Col sm="6">*/}
                        {/*    <Card style={{ minHeight: "305px" }}>*/}
                        {/*        <CardHeader className="card-header-dark">*/}
                        {/*            <h5 style={{ fontSize:"18.5px" }}>Freshwater Values, Priorities, or Outcomes&nbsp;&nbsp;&nbsp;*/}
                        {/*                <img className="featureIcon" src="/images/info_button_lt.png" data-tooltip-id="my-tooltip-4" onClick={(e) => e.stopPropagation()} /></h5>*/}
                        {/*            <ReactTooltip opacity="1" className="overrideMe" globalCloseEvents={{ escape: true, clickOutsideAnchor: true, scroll: true, resize: true }} openOnClick="true" clickable="true" style={{ marginTop: "-1vh", backgroundColor: "#e2f2f3", color: "black", maxWidth: "25vw", fontWeight: "750", wordBreak: 'normal', overflowWrap: 'break-word' }}*/}
                        {/*                id="my-tooltip-4"*/}
                        {/*                place="top"*/}
                        {/*                variant="info"*/}
                        {/*                render={({ content, activeAnchor }) => (*/}
                        {/*                    <>*/}
                        {/*                        <Row>*/}
                        {/*                            <Col>*/}
                        {/*                                <p style={{ fontWeight: "lighter" }}>*/}
                        {/*                                    Click and drag the small diagonal lines at the bottom right-hand side for the text box to expand the box.*/}
                        {/*                                </p>*/}
                        {/*                            </Col>*/}
                        {/*                        </Row>*/}
                        {/*                    </>*/}
                        {/*                )}*/}
                        {/*            />*/}
                        {/*        </CardHeader>*/}
                        {/*        <CardBody>*/}
                        {/*            */}{/*<ReadMoreContent longText="Include areas identified in applicable district or regional plans, iwi management plans, action plans under the National Policy Statement for Freshwater Manager, or other secondary legislation." />*/}
                        {/*            <p>Include areas identified in applicable district or regional plans, iwi management plans, action plans under the National Policy Statement for Freshwater Manager, or other secondary legislation.</p>*/}
                        {/*            <FormGroup>*/}
                        {/*                <Row className="mb-3">*/}
                        {/*                    <Col sm={12}>*/}
                        {/*                        <Input*/}
                        {/*                            id="freshwaterValuesPrioritiesOutcomes"*/}
                        {/*                            name="freshwaterValuesPrioritiesOutcomes"*/}
                        {/*                            type="textarea"*/}
                        {/*                            value={freshwaterValuesPrioritiesOutcomes}*/}
                        {/*                            onChange={(e) => { setFreshwaterValuesPrioritiesOutcomes(e.target.value); setCatchmentOverviewChanged(true); }}*/}
                        {/*                            style={{ minHeight: "150px" }} */}
                        {/*                        />*/}
                        {/*                    </Col>*/}
                        {/*                </Row>*/}
                        {/*            </FormGroup>*/}
                        {/*        </CardBody>*/}
                        {/*    </Card>*/}
                        {/*</Col>*/}
                    </Row>
                    <br/>
                </Form>
            </CardBody>
        </>
    )
}

export default CatchmentOverview